import CardFunctionLogo from "../../pages/Function/FunctionLogo/CardFunctionLogo";
import Emergencycontactlogo from "../../pages/Function/FunctionLogo/Emergencycontactlogo";
import CustomURLsLogo from "../../pages/Function/FunctionLogo/CustomURLsLogo";
import Paymenticon from "../../pages/Function/FunctionLogo/Paymenticon";
// import UploadFilesIcon from "../../assets/images/function_page_icons/UploadFilesIcon.svg";
import UploadFilesIcon from "../../pages/Function/FunctionLogo/UploadFilesIcon";
import FormBuilderLogo from "../../pages/Function/FunctionLogo/FormBuilderLogo";
import MyMemoryLogo from "../../pages/Function/FunctionLogo/MyMemoryLogo";
import MedicalIDLogo from "../../pages/Function/FunctionLogo/MedicalIDLogo";

const FunctionCreateCardsData = [
  {
    id: 1,
    bgColor:
      "radial-gradient(52.22% 52.22% at 50% 39.76%, var(--gradient_color_dark) 0%, rgba(34, 160, 129, 0) 100%)",
    //image: cardfunctionlogo,
    image: (
      <CardFunctionLogo
        primaryColor="var(--button_text_color)"
        secondaryColor="var(--primary_button_color)"
      />
    ),
    title: "Digital Card",
    description: "Create Your Personal & Businesss Card",
    url: "/function/cards",
    function_type: "card",
    intro: `
      <h3>Digital Card</h3>
      <p>Create professional personal and business cards that are easily shareable and customizable.</p>
    `,
  },
  // {
  //   id: 2,
  //   bgColor:
  //     "radial-gradient(52.22% 52.22% at 50% 39.76%, #0288FF 0%, rgba(2, 136, 255, 0) 100%)",
  //   image: venmologo,
  //   title: "Venmo",
  //   description: "Link Your Venmo Account",
  //   url: "/function/venmoListing",
  // },
  {
    id: 3,
    bgColor:
      "radial-gradient(52.22% 52.22% at 50% 39.76%,var(--gradient_color_light) 0%, rgba(0, 214, 50, 0) 100%)",
    // image: paymenticon,
    image: (
      <Paymenticon
        primaryColor="var(--button_text_color)"
        secondaryColor="var(--primary_button_color)"
      />
    ),
    title: "Payment Service",
    description: "Link Your Payment Service Account",
    url: "/function/paymentListing",
    function_type: "payment",
    intro: `
      <h3>Payment Service</h3>
      <p>Connect your preferred payment platform to receive or make payments effortlessly.</p>
    `,
  },
  {
    id: 4,
    bgColor:
      " radial-gradient(52.22% 52.22% at 50% 39.76%, var(--gradient_color_dark) 0%, rgba(34, 160, 129, 0) 100%)",
    //image: emergencycontactlogo,
    image: (
      <Emergencycontactlogo
        primaryColor="var(--button_text_color)"
        secondaryColor="var(--border_color)"
      />
    ),
    title: "Emergency Contact",
    description: "For Emergency Purpose",
    url: "/function/emergencycontacts",
    function_type: "emergency_contact",
    intro: `
      <h3>Emergency Contact</h3>
      <p>Store emergency contact details for immediate access during critical situations.</p>
    `,
  },
  {
    id: 5,
    bgColor:
      "radial-gradient(52.22% 52.22% at 50% 39.76%, var(--gradient_color_dark) 0%, rgba(34, 160, 129, 0) 100%) ",
    //image: customurlslogo,
    image: (
      <CustomURLsLogo
        primaryColor="var(--heading_text_color)"
        secondaryColor="var(--primary_button_color)"
        accentColor="var(--border_color)"
      />
    ),
    title: "Custom URL’s",
    description: "Create Your Custom URL’s",
    url: "/function/customurlslisting",
    function_type: "custom_url",
    intro: `
      <h3>Custom URLs</h3>
      <p>Generate personalized URLs for your services, content, or business offerings.</p>
    `,
  },
  {
    id: 6,
    bgColor:
      "radial-gradient(52.22% 52.22% at 50% 39.76%, var(--gradient_color_light) 0%, rgba(0, 214, 50, 0) 100%)",
    //image: UploadFilesIcon,
    image: (
      <UploadFilesIcon
        primaryColor="var(--heading_text_color)"
        secondaryColor="var(--primary_button_color)"
      />
    ),
    title: "File Upload URL",
    description: "Upload and Share documents",
    url: "/function/fileupload",
    function_type: "file_upload",
    intro: `
      <h3>File Upload</h3>
      <p>Securely upload and share important documents and files.</p>
    `,
  },
  {
    id: 7,
    bgColor:
      "radial-gradient(52.22% 52.22% at 50% 39.76%, var(--gradient_color_dark) 0%, rgba(34, 160, 129, 0) 100%) ",
    //image: FormBuilderIcon,
    image: (
      <FormBuilderLogo
        primaryColor="var(--heading_text_color)"
        secondaryColor="var(--primary_button_color)"
      />
    ),
    title: "Lead Builder",
    description: "For Lead Generation",
    url: "/function/formBuilderListing",
    function_type: "form_builder",
    intro: `
      <h3>Lead Builder</h3>
      <p>Create custom lead generation forms to grow your connections base.</p>
    `,
  },
  {
    id: 8,
    bgColor:
      "radial-gradient(52.22% 52.22% at 50% 39.76%, var(--gradient_color_dark) 0%, rgba(34, 160, 129, 0) 100%) ",
    image: (
      <MyMemoryLogo
        primaryColor="var(--button_text_color)"
        secondaryColor="var(--primary_button_color)"
      />
    ),
    title: "Memory",
    description: "Create Your Audio & video Link",
    url: "/function/memoryListing",
    function_type: "memory",
    intro: `
      <h3>Memory</h3>
      <p>Capture and share audio or video memories in a secure digital format.</p>
    `,
  },
  {
    id: 9,
    bgColor:
      "radial-gradient(52.22% 52.22% at 50% 39.76%, var(--gradient_color_dark) 0%, rgba(34, 160, 129, 0) 100%) ",
    image: (
      <MedicalIDLogo
        primaryColor="var(--button_text_color)"
        secondaryColor="var(--border_color)"
      />
    ),
    title: "Medical ID",
    description: "Create Your Medical ID",
    url: "/function/medicalListing",
    function_type: "medical_id",
    intro: `
      <h3>Medical ID</h3>
      <p>Maintain vital health and medical information for emergencies and quick reference.</p>
    `,
  },
];

export default FunctionCreateCardsData;
